declare global {
  interface Window {
    $$epiforms: any;
  }
}

document.addEventListener("DOMContentLoaded", () => {
  window.$$epiforms().ready(() => {
    window.$$epiforms(document).on(
      "input blur change",
      ".Form__Element :input",
      (event: any) => {
        var $field = window.$$epiforms(event.currentTarget);
        var isValid = event.currentTarget.checkValidity();
        var $formElement = $field.closest(".Form__Element");

        // Remove error UI if field is now valid
        if (isValid) {
          $formElement.removeClass("ValidationError");
          $formElement.addClass("ValidationSuccess");
          // Remove error message if present
          $formElement.find(".Form__Element__ValidationError, .field-validation-error, .Form__Error").each((index: number, element: HTMLElement) => {
            element.style.display = "none";
            element.textContent = "";
          });
        }
      }
    );
  });
});